(function () {
    'use strict';
    var controllerId = 'avvisoAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', avvisoAddFn]);

    function avvisoAddFn($scope, $uibModalInstance, datacontext) {
        $scope.avviso = {};
        $scope.titolo = 'Nuovo Avviso';
        $scope.avviso.Data = new Date();

        //DatePicker (gestione del calendario)
        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;            
        };        
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.format = 'dd/MM/yyyy';
        
        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addEditItem($scope.avviso);
                
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };        

        function addEditItem(avviso) {
            if ($scope.edit) 
                return datacontext.avviso_update(avviso).then(function (data) {
                    if (!data) return null;

                    return data;
                });            
            else 
                return datacontext.avviso_add(avviso).then(function (data) {
                    if (!data) return null;

                    return data;
                });
        }
    }
})();